// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const genesect: PokeData = {
  "id": 649,
  "name": "genesect",
  "height": 15,
  "weight": 825,
  "base_experience": 270,
  "types": [
    PokeType.BUG,
    PokeType.STEEL
  ],
  "api_moves": [
    "hyper-beam",
    "quick-attack",
    "screech",
    "self-destruct",
    "tri-attack",
    "slash",
    "zap-cannon",
    "lock-on",
    "fury-cutter",
    "metal-claw",
    "metal-sound",
    "signal-beam",
    "magnet-rise",
    "x-scissor",
    "bug-buzz",
    "magnet-bomb",
    "flame-charge",
    "simple-beam",
    "techno-blast",
    "fell-stinger"
  ],
  "moves": [
    "quick-attack",
    "tri-attack",
    "zap-cannon",
    "metal-claw",
    "metal-sound",
    "bug-buzz",
    "magnet-bomb",
    "behemoth-bash",
    "bug-bite",
    "meteor-mash",
    "sticky-web",
    "metal-rush",
    "iron-defense"

  ],
  "evolution_chain": {
    "id": 336,
    "item": null,
    "species": [
      {
        "name": "genesect",
        "order": 650,
        "types": [
          PokeType.BUG,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 131,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
